import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef
} from '@angular/core';

@Component({
  selector: 'app-popover-list-selector',
  templateUrl: './popover-list-selector.component.html',
  styleUrls: ['./popover-list-selector.component.scss']
})
export class PopoverListSelectorComponent {
  @ViewChild('trigger') triggerElement!: ElementRef;
  @ViewChild('popoverContent') popoverContent!: ElementRef;

  @Input() items: any[] = [];
  @Input() selectedItem: any = null;
  @Input() label: string = 'Select';
  @Input() triggerIcon: string = '';
  @Input() displayField: string = 'name';
  @Input() valueField: string = 'id';
  @Input() imageField: string = '';
  @Input() placeholder: string = 'No selection';
  @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'bottom';
  @Input() disabled: boolean = false;

  @Output() itemSelected = new EventEmitter<any>();
  @Output() visibleChange = new EventEmitter<boolean>();

  isDropdownOpen = false;

  onTriggerClick(event: Event): void {
    if (!this.disabled) {
      event.stopPropagation();
      this.toggleDropdown();
    }
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.visibleChange.emit(this.isDropdownOpen);
  }

  onItemClick(item: any): void {
    this.selectedItem = item;
    this.itemSelected.emit(item);
    this.closeDropdown();
  }

  closeDropdown(): void {
    this.isDropdownOpen = false;
    this.visibleChange.emit(false);
  }

  getDisplayValue(item: any): string {
    if (!item) {
      return this.placeholder;
    }
    if (typeof item === 'string' || typeof item === 'number') {
      return String(item);
    }
    return typeof item === 'object' && item[this.displayField]
      ? item[this.displayField]
      : this.placeholder;
  }

  getImageUrl(item: any): string | null {
    if (!this.imageField || !item) {
      return null;
    }
    return typeof item === 'object' && item[this.imageField] ? item[this.imageField] : null;
  }

  hasImage(item: any): boolean {
    return this.getImageUrl(item) !== null;
  }

  getTriggerLabel(): string {
    const selectedValue = this.getDisplayValue(this.selectedItem);
    return selectedValue !== this.placeholder ? selectedValue : this.label;
  }

  getTriggerClasses(): { [key: string]: boolean } {
    return {
      'trigger-disabled': this.disabled,
      'trigger-open': this.isDropdownOpen
    };
  }

  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    const triggerContains = this.triggerElement && this.triggerElement.nativeElement.contains(target);
    const popoverContains = this.popoverContent && this.popoverContent.nativeElement.contains(target);

    if (!triggerContains && !popoverContains && this.isDropdownOpen) {
      this.closeDropdown();
    }
  }
}
